exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".chip[data-v-4427acd3]{position:relative;width:60px;height:40px;border-radius:6px;margin-top:20px;background:#ccc}.chip[data-v-4427acd3]:before{content:\"\";position:absolute;width:40px;height:23px;top:50%;transform:translateY(-50%);border-radius:0 5px 5px 0;background:#d9d9d9}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4427acd3","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/Chip.vue
// module id = 782
// module chunks = 0